module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/role-components/role-list/role-list.component.css
// module id = ./src/app/role-components/role-list/role-list.component.css
// module chunks = main